import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerDataRouterApp, registerNavigatorApp} from '@github-ui/react-core/register-app'
import {App} from './App'
import {PullRequestErrorState} from './components/PullRequestErrorState'
import {pullRequestsAppBuilder} from './config/app-builder'
import {CommitsEntrypoint} from './routes/Commits'
import {pullRequestsCommitsRoute} from './routes/commits-route'
import {CommitsEntrypointFuture} from './routes/CommitsFuture'
import {FilesEntrypoint} from './routes/Files'
import {CommitsRoutePath, FilesRoutePath} from './routes/route-paths'
import type {RouteObject} from '@github-ui/react-router'
import {pullRequestsLayoutRoute} from './routes/layout-route'
import {LayoutEntrypoint} from './routes/Layout'
import {pullRequestsFilesRoute, pullRequestsFilesWithRangeRoute} from './routes/files-route'
import {FilesEntrypointFuture, FilesWithRangeEntrypointFuture} from './routes/FilesFuture'

// This app registers the app *twice*, under the same name: 'pull-requests'.
// Once as a navigator app, and once as a data router app.
// At runtime, a feature flag determines which app is used.

registerNavigatorApp('pull-requests', () => ({
  App,
  routes: [
    jsonRoute({path: CommitsRoutePath, Component: CommitsEntrypoint}),
    jsonRoute({path: FilesRoutePath, Component: FilesEntrypoint}),
  ],
}))

const commitsRouteWithLayout: RouteObject[] = [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
    ],
  }),
]

const dataRouterRoutes: RouteObject[] = [
  pullRequestsLayoutRoute.toRoute({
    ErrorBoundary: PullRequestErrorState,
    Component: LayoutEntrypoint,
    children: [
      pullRequestsCommitsRoute.toRoute({
        Component: CommitsEntrypointFuture,
      }),
      pullRequestsFilesRoute.toRoute({
        Component: FilesEntrypointFuture,
      }),
      pullRequestsFilesWithRangeRoute.toRoute({
        Component: FilesWithRangeEntrypointFuture,
      }),
    ],
  }),
]

export const pullRequestsApp = pullRequestsAppBuilder.createDataRouterAppFromRoutes(params => {
  if (params.isEnabled('react_data_router_pull_request_files')) {
    return dataRouterRoutes
  }
  return commitsRouteWithLayout
})

registerDataRouterApp(pullRequestsApp)
